import React, { useCallback, useEffect, useMemo, useState, forwardRef, useImperativeHandle } from "react";
import axios from "axios";
import { Paper } from "@material-ui/core";
import { BootstrapTable } from "react-bootstrap-table";
import { toast } from "react-toastify";

const SelectionRights = forwardRef(
  (
    {
      className = "",
      initialData = [],
      initialDataSelection = [],
      title,
      getUrl,
      getProcess,
      getSelectedUrl,
      getSelectedProcess = () => {},
      insertUrl,
      insertParams = () => {},
      insertAllUrl,
      insertAllParams = () => {},
      deleteUrl,
      deleteParams = () => {},
      deleteAllUrl,
      deleteAllParams = () => {},
      children,
    },
    ref
  ) => {
    const userInfo = useMemo(() => JSON.parse(localStorage.getItem("userInfo")), []);
    const [data, setData] = useState(initialData);
    const [selected, setSelected] = useState(initialDataSelection);
    const [tempSelected, setTempSelected] = useState(initialDataSelection);


    /**
     * GET
     */
    const requestData = useCallback(() => {
      const url =
        process.env.REACT_APP_API2_URL + (getUrl instanceof Function ? getUrl(userInfo) : getUrl);
      axios.get(url).then((response) => {
        const result = getProcess instanceof Function ? getProcess(response.data) : response.data;
        setData(result);
      });
    }, [getUrl, userInfo, getProcess]);

    const requestDataSelected = useCallback(() => {
      const url =
        process.env.REACT_APP_API2_URL +
        (getSelectedUrl instanceof Function ? getSelectedUrl(userInfo) : getSelectedUrl);
      axios.get(url).then((response) => {
        const result = getSelectedProcess(response.data).map(x => x.idRight ?? x);
        setSelected(result);
        setTempSelected(result); // Sincronizamos tempSelected con selected
      });
    }, [getSelectedUrl, getSelectedProcess, userInfo]);


    /**
     * INSERT AND DELETE
     */

    const applyChanges = useCallback(() => {
        const toInsert = tempSelected
          .filter((item) => !selected.includes(item))
          .map((row) => data.find((d) => d.idRight === row));
      
        const toDelete = selected
          .filter((item) => !tempSelected.includes(item))
          .map((row) => data.find((d) => d.idRight === row));
      
        const hasChanges = toInsert.length > 0 || toDelete.length > 0;
      
        const insertPromise =
          toInsert.length > 0
            ? axios.post(
                process.env.REACT_APP_API2_URL + insertAllUrl,
                insertAllParams(userInfo, toInsert)
              )
            : Promise.resolve({ data: 0 }); // Respuesta simulada para mantener lógica uniforme
      
        const deletePromise =
          toDelete.length > 0
            ? axios.post(
                process.env.REACT_APP_API2_URL + deleteAllUrl,
                deleteAllParams(userInfo, toDelete)
              )
            : Promise.resolve({ data: 0 }); // Respuesta simulada para mantener lógica uniforme
      
        Promise.all([insertPromise, deletePromise])
          .then((responses) => {
            if (hasChanges) {
              const [insertResponse, deleteResponse] = responses;
      
              if (insertResponse.data === -1 || deleteResponse.data === -1) {
                toast.error("Update failed!", "Error");
              } else {
                toast.success("Update successful!", "Success");
              }
      
              // Refrescar datos seleccionados
              requestDataSelected();
            }
          })
          .catch((error) => {
            toast.error("An error occurred while updating.", "Error");
            console.error("Error:", error);
          });
      }, [
        tempSelected,
        selected,
        insertAllUrl,
        insertAllParams,
        deleteAllUrl,
        deleteAllParams,
        userInfo,
        data,
        requestDataSelected,
      ]);
      
      


    /**
     * Exponer funciones mediante `ref`
     */
    useImperativeHandle(ref, () => ({
      applyChanges,
    }));

    /**
     * Initial load
     */
    useEffect(() => {
      if (getUrl) {
        requestData();
        requestDataSelected();
      }
    }, [getUrl, requestData, requestDataSelected]);

    /**
     * Selección Temporal
     */
    const onTempSelect = useCallback(
      (row, isSelected) => {
        setTempSelected((prev) =>
          isSelected ? [...prev, row.idRight] : prev.filter((id) => id !== row.idRight)
        );
        
      },
      []
    );

    const onTempSelectAll = useCallback(
      (isSelected, rows) => {
        const ids = rows.map((row) => row.idRight);
        setTempSelected(
          isSelected
            ? [...new Set([...tempSelected, ...ids])]
            : tempSelected.filter((id) => !ids.includes(id))
        );
      },
      [tempSelected]
    );

    const selectRowProp = {
      mode: "checkbox",
      selected: tempSelected,
      onSelect: onTempSelect,
      onSelectAll: onTempSelectAll,
      clickToSelect: true,
    };

    return (
      <div id="main-div" className={`${className} !h-max`}>
        <Paper>
          {title ? <h2>{title}</h2> : null}
          <BootstrapTable data={data} selectRow={selectRowProp} hover>
            {children}
          </BootstrapTable>
        </Paper>
      </div>
    );
  }
);

export default SelectionRights;
